import { useCallback, useState } from 'react';

import { UpdateExperimentModal, type UpdateExperimentModalProps } from '../UpdateExperimentModal';

export function useUpdateExperimentModal() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const UpdateExperimentModalComponent = useCallback(
    ({
      isEditMode = false,
      onConfirm = () => undefined,
      onStartSuccess = () => undefined,
      onCancel = () => undefined,
      isLoading = false,
      experiment,
      draftIterationProps,
    }: Partial<UpdateExperimentModalProps>) => (
      <UpdateExperimentModal
        onCancel={onCancel}
        onConfirm={onConfirm}
        isEditMode={isEditMode}
        isLoading={isLoading}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        experiment={experiment}
        onStartSuccess={onStartSuccess}
        draftIterationProps={draftIterationProps}
      />
    ),
    [isModalOpen, setIsModalOpen],
  );

  return {
    isModalOpen,
    setIsModalOpen,
    UpdateExperimentModal: UpdateExperimentModalComponent,
  };
}
